import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useModalContext } from './modal-context-provider';

export type ModalHeaderProps = React.HTMLAttributes<HTMLDivElement>;

export const ModalHeader = ({
  children,
  className,
  ...props
}: ModalHeaderProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-modal__header');
  const { disableLegacy } = useModalContext();
  useEffect(() => disableLegacy(), []);
  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};
